import { render } from "./MetricsView.vue?vue&type=template&id=14252a3a"
import script from "./MetricsView.vue?vue&type=script&lang=js"
export * from "./MetricsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__